// Le viste su cui il portale puo' riaprire all'ingresso, e nient'altro
// (segnalazione del cliente OwlCaveLabs/syndesia-l2c-support#3).
//
// Il dettaglio di una lead non conta. In questo portale si atterra spesso su
// `/l/123` cliccando il link dentro una notifica automatica, e quello e' un
// arrivo, non la scelta di dove si lavora: se contasse, basterebbe una mail
// spedita da una regola per riscrivere la vista del giorno dopo.

export const REMEMBERABLE_VIEWS = ['/l', '/o', '/co'];

export const DEFAULT_VIEW = '/l';

export function isRememberableView(path: string | null | undefined): boolean {
  return typeof path === 'string' && REMEMBERABLE_VIEWS.includes(path);
}

// Cosa aprire su `/`. Se la vista memorizzata non e' piu' accessibile non ci
// pensiamo qui: la guardia del router manda gia' sulla prima vista consentita.
export function initialView(stored: string | null | undefined): string {
  return isRememberableView(stored) ? (stored as string) : DEFAULT_VIEW;
}
